import Spinner from "@rio-cloud/rio-uikit/Spinner"
import { ReactElement, ReactNode } from "react"

const SEARCH_PENDING_STATE_STYLE = `
    .transport-order-table-search {
        position: relative;
    }

    .transport-order-table-search.search-pending .clearButton {
        visibility: hidden;
        pointer-events: none;
    }

    .transport-order-table-search-spinner {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        z-index: 2;
        pointer-events: none;
    }
`

export const TableSearchPendingState = (props: {
    isPending: boolean
    children: ReactNode
}): ReactElement => {
    const { isPending, children } = props

    return (
        <>
            <style>{SEARCH_PENDING_STATE_STYLE}</style>
            <div className={`transport-order-table-search ${isPending ? "search-pending" : ""}`}>
                {children}
                {isPending
                    ? <div className="transport-order-table-search-spinner" aria-hidden="true">
                        <Spinner isInline/>
                    </div>
                    : null}
            </div>
        </>
    )
}
